import { ImportedData, ImportQueryParams } from '@breathelife/types';

import ApiService from './ApiService';

export async function uploadDataForImport(query: ImportQueryParams, importData: ImportedData): Promise<ImportedData> {
  const { data } = await ApiService.admin.uploadDataForImport(query, importData);
  return data;
}
